import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

export default class PassCultureEvent extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][PassCulture] organizationId is mandatory');
        }
        if (!eventId) {
            throw new ArgumentError('[Model][PassCulture] eventId is mandatory');
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/providers/passculture`;
    }

    // BaseAPIModel getAll tries to do a map on the response and throws an error (expecting an array not an obj)
    static getAll({ organizationId, eventId }) {
        return fetcher.get(`${this.listUrl({ organizationId, eventId })}`);
    }

    static getVenues({ organizationId, eventId, siret }) {
        return fetcher.get(`${this.listUrl({ organizationId, eventId })}/get-venues?siret=${siret}`);
    }

    static searchAddresses({ organizationId, eventId, street, city, postalCode }) {
        return fetcher.get(`${this.listUrl({ organizationId, eventId })}/address?street=${street}&city=${city}&postal_code=${postalCode}`, { cache: false });
    }

    static createAddresses({ organizationId, eventId, street, city, postalCode, lat, long }) {
        return fetcher.post(`${this.listUrl({ organizationId, eventId })}/address`, {
            data: { street, city, postal_code: postalCode, coordinates: { lat, long } }
        });
    }
}
